import { Component, Input } from '@angular/core';
import { HisUiService } from 'hisng';

/*  const pDialogKey for InformationDialogComponent */
export const INFORMATION_PDIALOG_KEY = 'informationDialogKey';

@Component( {
    selector: 'psv-information-dialog',
    templateUrl: './information-dialog.component.html'
} )

export class InformationDialogComponent {
    @Input() width = 850;
    public pDialogKey; // key of <p-confirmDialog>

    constructor( private hisUiService: HisUiService ) {
        this.pDialogKey = INFORMATION_PDIALOG_KEY; // set default const key
    }
}
